import { Vector3 as i, Euler as c, MathUtils as f } from "three";
import { getRgView as u } from "../core/index17.js";
function g(n, p, a) {
  var e, o;
  let t = n.clone(), r = (o = (e = u(p, a)) == null ? void 0 : e.parent) == null ? void 0 : o.userData;
  for (; r && Object.keys(r).length; ) {
    const l = new i().fromArray(r.pos), s = new c().fromArray(r.rot.map((m) => m * f.DEG2RAD));
    t = l.add(t.applyEuler(s)), r = r.parent;
  }
  return t;
}
export {
  g as applyParentTransforms
};
//# sourceMappingURL=index3.js.map
